// Sample card from Airbnb
import React, {useState, useEffect} from "react";
import classes from "./styles.module.css"; 
import { useParams } from "react-router-dom";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs"
import APIConfig from "../../api/APIConfig";

import {
    Box,
    Center,
    Icon,
    Text,
    VStack,
    HStack,
} from '@chakra-ui/react';

const DokumenPartisipan = (props) => {
    const [peserta, setPeserta] = useState([]);
    const [fileInfo2, setFileInfo2] = useState([]);
    const [urlDokumen, setUrlDokumen] = useState('');

    const { id } = useParams();

    const getLowonganPeserta = async(id) => {  
        const response = await APIConfig.get(`/v1/lowonganpeserta/lowongan/${id}`);
        const result = await response.data;
        setPeserta(result.peserta);
        setFileInfo2(result.cvPeserta);
        setUrlDokumen(result.urlDokumenPeserta);
    };

    useEffect(() => {
        getLowonganPeserta(id)
    }, []);


    return (
        <div>
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'}>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                spacing={'50px'}
                align='stretch'
                >
                    <Text
                        pt={5}
                        paddingBottom={7}
                        color={'gray.900'}
                        fontWeight={650}
                        fontSize={'3xl'}>
                        Dokumen {peserta.namaPeserta}
                    </Text>
                    <div>
                        <h3 className={classes.h} >Curriculum Vitae</h3>
                        {fileInfo2 !== null ? 
                        <div>
                            <HStack pt={5} pb={5}>
                                <Icon mr="5px" fontSize={'xl'} as={BsFillFileEarmarkPdfFill} />
                                <a href={fileInfo2.url} style={{marginRight: '30px'}}>
                                    <p className={classes.p}>{fileInfo2.name}</p>
                                </a>
                            </HStack>
                        </div>
                        :
                        <div>
                            <HStack pt={5} pb={5}>
                                <p className={classes.p}>-</p>
                            </HStack>
                        </div>
                        }
                        <br></br><br></br>
                        <h3 className={classes.h} >URL Tambahan</h3>
                        {urlDokumen !== null ?
                        <div>
                            <HStack pt={5} pb={5}>
                                <a href={urlDokumen} style={{marginRight: '30px'}}>
                                    <p className={classes.p}>{urlDokumen}</p>
                                </a>
                            </HStack>
                        </div>
                        :
                        <div>
                            <HStack pt={5} pb={5}>
                                <p className={classes.p}>-</p>
                            </HStack>
                        </div>
                        }
                    </div>
                </VStack>
            </Box>
        </VStack>
        </Center>
        </div>
      );
  }

export default DokumenPartisipan;